module.exports = __webpack_public_path__ + "static/assets/f33a27ab58063c20533b07920ac2fd66.svg";